import { Injectable, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient } from '@angular/common/http';
import { SiteModel } from '../models/site.model';

@Injectable()
export class SiteService {
  constructor(private http: HttpClient, @Inject('API_BASE_URL') private baseUrl: string) { }

  all(clientId? : number): Promise<any> {
    let url = this.baseUrl + 'sites';

    if (clientId) {
      url = url + '?clientId=' + clientId;
    }

    let promise = new Promise((resolve, reject) => {
      this.http.get(url)
        .toPromise()
        .then(res => {
          var siteData = (res as SiteModel);
          resolve(siteData);
        })
        .catch(reason => {
          reject({
            status: reason.status,
            description: "site request failed"
          });
        });
    });

    return promise;
  }
}

